var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsrbAo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.42,
    height: 90.628,
    viewBox: "0 0 60.42 90.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(-1240 -867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(1239.999 867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M330.654,513.479H270.235v90.628h60.419V513.479Z",
    transform: "translate(-270.235 -513.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(0.879 0.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M329.475,514.117V602.8H270.812V514.117h58.663",
    transform: "translate(-270.812 -514.117)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 52.337,
    height: 14.706,
    transform: "translate(2.951 3.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 52.367,
    height: 54.062,
    transform: "translate(2.928 21.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(2.939 78.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M272.743,572.732v-7.178h10.512v1.68h-6.289v1.026h5.323v1.674h-5.323v1.124H283.5v1.674Z",
    transform: "translate(-272.743 -565.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M288.2,567.706a.79.79,0,0,0-.609-.486,3.843,3.843,0,0,0-1.092-.132c-.927,0-1.344.151-1.344.419,0,1.061,7.413.4,7.413,3.007,0,1.661-2.491,2.474-6.032,2.474-3.4,0-5.619-1.107-5.709-2.4h4.044a1.029,1.029,0,0,0,.7.566,3.809,3.809,0,0,0,1.2.181c1.055,0,1.757-.187,1.757-.527,0-1.088-7.419-.342-7.419-3.078,0-1.524,2.366-2.29,5.591-2.29,3.578,0,5.207,1.015,5.516,2.27Z",
    transform: "translate(-268.517 -565.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M294.147,568.667h1.663c1.3,0,2.007-.19,2.007-.685s-.714-.749-1.7-.749h-1.969Zm0,1.564v2.5h-4.223v-7.178h6.087c4.292,0,5.709.656,5.709,2.051,0,.83-.659,1.519-2.165,1.761,1.36.273,2.183.443,2.183,1.891,0,.933-.053,1.258.446,1.258v.218H297.9a2.792,2.792,0,0,1-.212-1.256c0-.942-.286-1.245-2.255-1.245Z",
    transform: "translate(-263.766 -565.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M303.6,567.233v1.2h1.76c.842,0,1.454-.216,1.454-.627,0-.562-.833-.574-1.722-.574Zm0,2.5v1.323h1.844c1.046,0,1.832-.122,1.832-.658,0-.627-.982-.665-2.331-.665Zm-4.22,3v-7.178h6.161c2.9,0,5.21.39,5.21,1.81,0,.74-.862,1.279-1.682,1.559,1.395.2,2.142.874,2.142,1.644,0,1.6-2.2,2.165-5.551,2.165Z",
    transform: "translate(-258.827 -565.374)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(7.679 24.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M288.972,559.7l-.122-15.71,8.555,13.623Zm20.084-5.953a10.819,10.819,0,0,1-2.09.761c-5.386,1.335-9.212-1.593-10.694-6.717-1.089-3.761-.437-7.07,2.112-9.106l-6.206-8.754L278.6,533.3l-2.743,44.6,13.081-3.238-.046-5.782,13.3-3.307,3.151,5.018,13.3-3.3-9.588-13.544",
    transform: "translate(-275.856 -529.935)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(23.188 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M291.58,543.231c1.021,3.512,3.083,6.171,6.77,5.251a5.753,5.753,0,0,0,1.323-.506l-7.687-10.843c-1.154,1.494-1.095,3.734-.406,6.1",
    transform: "translate(-291.087 -537.134)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(22.528 6.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M294.824,536.979c3.7-.918,5.759,1.739,6.773,5.256.883,3.033.735,5.866-1.7,7.174l1.422,2.013c3.722-1.839,4.814-5.61,3.544-10-1.487-5.108-5.306-8.04-10.7-6.7a9.191,9.191,0,0,0-3.517,1.643l1.56,2.206a4.485,4.485,0,0,1,2.611-1.586",
    transform: "translate(-290.653 -534.393)",
    fill: "#1a1818"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(4.414 6.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M273.711,526.622l1.361-8.341h1.35l1.328,8.341h-1.079l-.268-1.85H275l-.277,1.85Zm1.978-6.735h-.015l-.466,3.6h.977Z",
    transform: "translate(-273.711 -518.129)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M276.7,518.28h1.711a1.181,1.181,0,0,1,.815.279,1.777,1.777,0,0,1,.481.808,5.623,5.623,0,0,1,.236,1.3q.062.77.062,1.737v.757c0,.289-.012.591-.034.907a8.4,8.4,0,0,1-.125.929,3.292,3.292,0,0,1-.276.816,1.712,1.712,0,0,1-.477.582,1.149,1.149,0,0,1-.726.227H276.7Zm1.026,7.06h.495a.5.5,0,0,0,.375-.157,1.128,1.128,0,0,0,.228-.5,5.354,5.354,0,0,0,.111-.894c.02-.367.032-.81.032-1.334,0-.385,0-.752-.012-1.1a6.313,6.313,0,0,0-.076-.918,1.778,1.778,0,0,0-.216-.636.453.453,0,0,0-.408-.234h-.528Z",
    transform: "translate(-272.152 -518.129)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M282.722,518.28v5.915a4.95,4.95,0,0,1-.085.929,2.742,2.742,0,0,1-.279.822,1.679,1.679,0,0,1-.51.588,1.331,1.331,0,0,1-.787.225,1.365,1.365,0,0,1-1.259-.693,3.654,3.654,0,0,1-.411-1.871V518.28h1.026v5.8a2.566,2.566,0,0,0,.172,1.1.5.5,0,0,0,.952-.04,2.785,2.785,0,0,0,.158-1.064v-5.8Z",
    transform: "translate(-270.743 -518.129)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M282.133,526.622V518.28h1.023v6.956h1.535v1.385Z",
    transform: "translate(-269.311 -518.129)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M286.9,518.28v1.387h-1.139v6.955h-1.023v-6.955h-1.142V518.28Z",
    transform: "translate(-268.548 -518.129)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M289.16,524.392a4.2,4.2,0,0,1-.155,1.286,1.761,1.761,0,0,1-.4.728,1.149,1.149,0,0,1-.554.324,2.46,2.46,0,0,1-.594.075,1.24,1.24,0,0,1-.77-.219,1.368,1.368,0,0,1-.452-.594,3.117,3.117,0,0,1-.206-.868,7.419,7.419,0,0,1-.026-1.034h1.025c0,.2,0,.388.012.568a2.108,2.108,0,0,0,.072.466.661.661,0,0,0,.172.318.443.443,0,0,0,.327.116.408.408,0,0,0,.387-.26,1.544,1.544,0,0,0,.128-.687,1.284,1.284,0,0,0-.152-.647,2.622,2.622,0,0,0-.382-.525c-.155-.166-.318-.33-.495-.5a3.7,3.7,0,0,1-.5-.576,3.261,3.261,0,0,1-.384-.769,3.3,3.3,0,0,1-.151-1.063,5.234,5.234,0,0,1,.076-.912,2.283,2.283,0,0,1,.262-.744,1.366,1.366,0,0,1,.5-.5,1.508,1.508,0,0,1,.78-.186,1.208,1.208,0,0,1,1.11.6,3.573,3.573,0,0,1,.315,1.906h-1c0-.155-.006-.306-.017-.458a2.061,2.061,0,0,0-.069-.4.8.8,0,0,0-.143-.289.307.307,0,0,0-.247-.11.437.437,0,0,0-.39.225,1.249,1.249,0,0,0-.14.664,1.376,1.376,0,0,0,.152.671,2.234,2.234,0,0,0,.384.507q.231.231.493.469a3.236,3.236,0,0,1,.5.553,2.824,2.824,0,0,1,.384.764A3.37,3.37,0,0,1,289.16,524.392Z",
    transform: "translate(-267.295 -518.176)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M291.2,526.806a1.268,1.268,0,0,1-.974-.364,2.174,2.174,0,0,1-.505-.968,6.549,6.549,0,0,1-.181-1.383c-.021-.514-.027-1.046-.027-1.592s.006-1.09.027-1.6a6.407,6.407,0,0,1,.181-1.375,2.187,2.187,0,0,1,.505-.965,1.493,1.493,0,0,1,1.953,0,2.152,2.152,0,0,1,.5.965,6.393,6.393,0,0,1,.184,1.375q.027.772.027,1.6t-.027,1.592a6.535,6.535,0,0,1-.184,1.383,2.141,2.141,0,0,1-.5.968A1.276,1.276,0,0,1,291.2,526.806Zm0-1.247a.4.4,0,0,0,.346-.18,1.272,1.272,0,0,0,.2-.548,6.25,6.25,0,0,0,.09-.951c.011-.39.02-.851.02-1.381s-.009-.993-.02-1.381a6.273,6.273,0,0,0-.09-.953,1.264,1.264,0,0,0-.2-.548.421.421,0,0,0-.69,0,1.345,1.345,0,0,0-.2.548,7.257,7.257,0,0,0-.087.953c-.014.388-.02.85-.02,1.381s.006.991.02,1.381a7.229,7.229,0,0,0,.087.951,1.354,1.354,0,0,0,.2.548A.4.4,0,0,0,291.2,525.559Z",
    transform: "translate(-265.455 -518.176)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M292.272,526.622V518.28h1.385l1.3,5.776h.014V518.28h.955v8.341h-1.346l-1.338-6.1h-.012v6.1Z",
    transform: "translate(-264.014 -518.129)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M295.247,526.622V518.28h1.022v6.956H297.8v1.385Z",
    transform: "translate(-262.459 -518.129)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M297.926,523.733l-1.285-5.453h1.117l.735,3.524.783-3.524h1.046l-1.373,5.453v2.888h-1.023Z",
    transform: "translate(-261.731 -518.129)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M300.3,519.55a5.555,5.555,0,0,0,.495-.566,3.671,3.671,0,0,0,.422-.732h.907v8.386H301.1v-6.451a5.026,5.026,0,0,1-.387.5c-.137.152-.277.3-.414.434Z",
    transform: "translate(-259.821 -518.144)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M303.514,526.78a1.139,1.139,0,0,1-1.023-.534,3.273,3.273,0,0,1-.344-1.723c0-.256.006-.5.024-.732a3.675,3.675,0,0,1,.094-.644,2.007,2.007,0,0,1,.212-.521,1.117,1.117,0,0,1,.365-.375v-.023a.744.744,0,0,1-.327-.259,1.4,1.4,0,0,1-.2-.408,2.314,2.314,0,0,1-.1-.528q-.027-.294-.027-.63a3.287,3.287,0,0,1,.333-1.687,1.193,1.193,0,0,1,1.99,0,3.285,3.285,0,0,1,.335,1.687c0,.224-.011.434-.026.63a2.388,2.388,0,0,1-.105.528,1.393,1.393,0,0,1-.2.408.744.744,0,0,1-.327.259v.023a1.147,1.147,0,0,1,.365.375,2.066,2.066,0,0,1,.212.521,3.54,3.54,0,0,1,.094.644c.018.231.024.476.024.732a3.255,3.255,0,0,1-.346,1.723A1.142,1.142,0,0,1,303.514,526.78Zm0-3.856a.268.268,0,0,0-.247.163,1.5,1.5,0,0,0-.122.4,3.872,3.872,0,0,0-.041.487c0,.169,0,.315,0,.443s.006.247.015.381a2.057,2.057,0,0,0,.059.373.749.749,0,0,0,.122.282.262.262,0,0,0,.216.107.269.269,0,0,0,.221-.107.774.774,0,0,0,.122-.282,1.925,1.925,0,0,0,.059-.373c.009-.134.015-.259.015-.381s0-.274,0-.443a3.867,3.867,0,0,0-.041-.487,1.346,1.346,0,0,0-.123-.4A.268.268,0,0,0,303.514,522.924Zm0-3.518a.231.231,0,0,0-.2.114.831.831,0,0,0-.113.282,2.391,2.391,0,0,0-.053.355q-.009.187-.009.342t.009.361a2.534,2.534,0,0,0,.05.367.759.759,0,0,0,.111.288.231.231,0,0,0,.2.113.236.236,0,0,0,.206-.113.812.812,0,0,0,.113-.288,2.351,2.351,0,0,0,.046-.367c.009-.129.011-.25.011-.361s0-.218-.011-.342a2.21,2.21,0,0,0-.049-.355.864.864,0,0,0-.116-.282A.232.232,0,0,0,303.514,519.405Z",
    transform: "translate(-258.854 -518.181)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M305.3,519.344h.752v2.276H307.2V522.9h-1.148v2.274H305.3V522.9h-1.154V521.62H305.3Z",
    transform: "translate(-257.809 -517.573)",
    fill: "#1a1818"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsrbAo);
export default __webpack_public_path__ + "static/media/esrb-ao.c25a5645e6a50376e7108822835160cf.svg";
export { ForwardRef as ReactComponent };